




































import { Component, Vue } from 'vue-property-decorator';
import BmnMap from '@/components/BmnMap.vue';
import BmnSidebar from '@/components/BmnSidebar.vue';
import BmnOrientationModal from '@/components/BmnOrientationModal.vue';
import BmnIntroductionModal from '@/components/BmnIntroductionModal.vue';

import communities from '@/assets/data/communities.json';
import routes from '@/assets/data/fietsroutes.json';
import locations from '@/assets/data/locations.json';
import projects from '@/assets/data/projects.json';

import { Community, CheckEvent } from '@/interfaces';

import HelpserService from '@/services/helper.service';
import BmnLoadingScreen from '../components/BmnLoadingScreen.vue';

@Component({
  components: {
    'bmn-map': BmnMap,
    'bmn-sidebar': BmnSidebar,
    'bmn-orientation-modal': BmnOrientationModal,
    'bmn-introduction-modal': BmnIntroductionModal,
    'bmn-loading-screen': BmnLoadingScreen
  },
})
export default class Home extends Vue {
  public communities = communities;
  public routes = routes;
  public locations = locations;
  public projects = projects;

  public communitiesChecked = false;
  public bRoutesChecked = false;
  public mirtChecked = false;
  public bakkoordChecked = false;

  public isPortrait = false;
  public introduction = false;
  public introduced = false;

  public sidebarVisible: boolean;

  public loaded = false;

  private helperService = new HelpserService();

  public checkboxAltered(event: CheckEvent): void {
    switch (event.name) {
      case 'Communities':
        this.communitiesChecked = event.checked;
        break;
      case 'Routes':
        this.bRoutesChecked = event.checked;
        break;
      case 'Wegenprojecten':
        this.mirtChecked = event.checked;
        this.bakkoordChecked = event.checked;
        break;
    }
  }

  public data() {
    return {
      bRoutesChecked: this.bRoutesChecked,
      communitiesChecked: this.communitiesChecked,
      mirtChecked: this.mirtChecked,
      bakkoordChecked: this.bakkoordChecked,
      sidebarVisible: this.sidebarVisible
    };
  }

  public mounted() {
    this.isPortrait = this.isPrtrt();

    window.addEventListener('resize', () => {
      this.isPortrait = this.isPrtrt();
    });

    if (this.helperService.isMobile()) {
      if (!this.isPortrait) {
        this.openIntroModal(true);
      } else {
        this.dismiss(false);
      }
    } else {
      this.dismiss(true);
    }

    window.addEventListener('orientationchange', event => {
      this.isPortrait = this.isPrtrt();
      if (this.isPortrait) {
        this.introduction = false;
      } else {
        if (!this.introduced) {
          this.openIntroModal(true);
        }
      }
    });
  }

  public onLoaded(): void {
    this.loaded = true;
  }

  public onInteractionWithMap(): void {
    this.sidebarVisible = false;
  }

  public openSidebar(): void {
    this.sidebarVisible = true;
  }

  public dismiss(introduced?: boolean): void {
    this.introduction = false;
    this.sidebarVisible = true;
    if (introduced) {
      this.introduced = true;
    }
  }

  public isPrtrt(): boolean {
    if (this.helperService.isPortrait(window)) {
      return true;
    }
    return false;
  }

  public openIntroModal(first?: boolean): void {
    this.introduction = true;
    if (first) {
      this.introduced = false;
    }
  }
}
